import { createSelector } from 'reselect';
import { RootState } from '../reducers/root.reducer';
import { colorPalette, generateHexColor } from '../../utils/general.utils';
import { getOperatorsMap } from './operators.selector';

export const getTotalHours = createSelector(
    (state: RootState) => state.ClientsCompanies.data,
    data => {
        return data.total_hours;
    },
);

export const getCompaniesData = createSelector(
    (state: RootState) => state.ClientsCompanies.data,
    data => {
        const companyData = data.companySummaries || [];
        const viewModelCompanyData = companyData.map((company, index) => ({
            id: company.company_id,
            companyName: company.company_name,
            hours: Math.floor(company.total_work_hours).toString().padStart(2, '0') + ':' + (company.total_work_minutes%60).toString().padStart(2, '0'),
            color: colorPalette[index] || generateHexColor(),
            total_work_hours: company.total_work_hours,
            total_work_minutes: company.total_work_minutes,
            forms101Processed: company.employee_form_count,
            payslipsUploaded: company.paycheck_count,

        })).sort((a, b) => b.total_work_minutes - a.total_work_minutes);

        return viewModelCompanyData;
    },
);

export const getPieCompaniesData = createSelector(
    getCompaniesData,
    (viewModelCompanyData) => {
        return viewModelCompanyData.map(item => {            
            return {
                id: item.id,
                label: item.companyName,
                value: item.total_work_minutes,
                shownLabel: Math.floor(item.total_work_hours).toString().padStart(2, '0') + ':' + (item.total_work_minutes%60).toString().padStart(2, '0'),
                color: item.color,
            };
        });
    }
);


export const getClientsData = createSelector(
    (state: RootState) => state.ClientsCompanies.data,
    getOperatorsMap,
    (data, operatorsMap) => { 
        const clientData = data.userSummaries || [];
        
        const viewModelClientData = clientData.map((user, index) => ({
            id: user.id,
            clientNumber: user.clientnumber,
            user_id: user.user_id,
            employeeName:  operatorsMap[user.clientnumber]?.name || user.first_name + ' ' + user.last_name || '',
            hours: Math.floor(user.total_work_hours).toString().padStart(2, '0') + ':' + (user.total_work_minutes%60).toString().padStart(2, '0'),
            companysHandled: user.companyCount,
            color: colorPalette[index+6] || generateHexColor(),
            total_work_hours: user.total_work_hours,
            total_work_minutes: user.total_work_minutes,
        })).sort((a, b) => b.total_work_minutes - a.total_work_minutes);
        return viewModelClientData;
    }
);


export const getPieClientsData = createSelector(
    getClientsData,
    (viewModelClientData) => {
        return viewModelClientData.map(item => {            
            return {
                id: item.id,
                label: item.employeeName,
                value: item.total_work_minutes,
                shownLabel: Math.floor(item.total_work_hours).toString().padStart(2, '0') + ':' + (item.total_work_minutes%60).toString().padStart(2, '0'),
                color: item.color,
            };
        });
    }
);

export const getExcelCompaniesData = createSelector(
    getCompaniesData,
    (viewModelCompanyData) => {
        const excelData = viewModelCompanyData.map(item => {            
            return {
                'companyName': item.companyName,
                'totalHours': item.hours,
                'payslipsUploaded': item.payslipsUploaded,
                'forms101Processed': item.forms101Processed,
            };
        });
        return excelData;
    }
);

export const getExcelClientsData = createSelector(
    getClientsData,
    (viewModelClientData) => {
        const excelData = viewModelClientData.map(item => {            
            return {
                'employeeName': item.employeeName,
                'totalHours': item.hours,
                'handledCompanys': item.companysHandled,
            };
        });
        return excelData;
    }   
);